import React from "react";
import Select from "react-select";

const BootstrapSelect = ({ size = "sm", width, className, ...props }) => {
    const safeClassName = "bootstrap-select";

    const baseHeight = size === "sm" ? 35 : size === "lg" ? 48 : 38;
    const fontSize = size === "sm" ? "0.875rem" : size === "lg" ? "1.25rem" : "1rem";
    const optionPadding = size === "sm" ? "2px 8px" : size === "lg" ? "10px 12px" : "6px 12px";

    const customStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: `${baseHeight}px`,
            height: `${baseHeight}px`,
            fontSize,
            borderColor: state.isFocused ? "#86b7fe" : "#ced4da",
            boxShadow: state.isFocused ? "0 0 0 0.25rem rgba(13,110,253,.25)" : "none",
            width: width || base.width, // ✅ allow optional width override
        }),
        valueContainer: (base) => ({
            ...base,
            padding: "0 6px",
            height: `${baseHeight}px`,
        }),
        indicatorsContainer: (base) => ({
            ...base,
            height: `${baseHeight - 2}px`,
        }),
        menu: (base) => ({
            ...base,
            fontSize,
            zIndex: 9999,
            height: '5px'
        }),
        menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
        }),
        option: (base, { isFocused, isSelected }) => ({
            ...base,
            fontSize,
            padding: optionPadding,
            backgroundColor: isSelected ? "#0d6efd" : isFocused ? "#e9ecef" : "white",
            color: isSelected ? "white" : "black",
            cursor: "pointer",
        }),
    };

    return (
        <Select
            className={safeClassName}
            classNamePrefix="bootstrap-select"
            styles={customStyles}
            menuPortalTarget={document.body}
            {...props}
        />
    );
};

export default BootstrapSelect;
